import { useMutation } from "vue-query"
import { useContext } from "@nuxtjs/composition-api"

import { ApiPaths, Events } from "@/enums"
import {
  GoogleAnalyticsID,
  TrackedEvent,
  TrackedEventData,
  UserAnalyticsID,
} from "@/types/models/TrackedEvent"
import { CustomMutationHook } from "@/types/vue-query"

export type MutationBody = {
  userAnalyticsID: UserAnalyticsID
  googleAnalyticsID: GoogleAnalyticsID
  event: Events
  data: TrackedEventData
}

export const useTrackedEventMutation: CustomMutationHook<
  MutationBody,
  TrackedEvent
> = (options) => {
  const { $axios } = useContext()

  return useMutation(async (body: MutationBody) => {
    const { data } = await $axios.post<TrackedEvent>(
      ApiPaths.POST_TRACKED_EVENT,
      {
        ...body,
      },
    )
    return data
  }, options)
}
